import Chevron from '@img/icons/chevron.svg';
import React, { FunctionComponent } from 'react';
import { CarouselButtonStyles } from './CarouselButton.styles';

export type CarouselButtonTheme = 'black' | 'red' | 'white';

export interface CarouselButtonProps {
  appearance?: 'default' | 'round';
  direction: 'left' | 'right';
  disabled?: boolean;
  hideLine?: boolean;
  hideLineOnMobile?: boolean;
  hideWhenDisabled?: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  theme?: CarouselButtonTheme;
  size?: 'normal' | 'small';
}

const CarouselButton: FunctionComponent<CarouselButtonProps> = ({
  appearance = 'default',
  direction,
  disabled = false,
  hideLine = false,
  hideLineOnMobile = false,
  hideWhenDisabled = true,
  onClick,
  theme = 'black',
  size = 'normal',
}) => {
  const _onClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
    if (disabled) {
      return;
    }

    onClick(e);
  };

  return (
    <CarouselButtonStyles.Button
      appearance={appearance}
      direction={direction}
      disabled={disabled}
      hideLine={hideLine}
      hideLineOnMobile={hideLineOnMobile}
      hideWhenDisabled={hideWhenDisabled}
      onClick={_onClick}
      theme={theme}
      data-size={size}
    >
      <i className="chevron">
        <Chevron />
      </i>

      {appearance === 'round' ? (
        <i className="border-detail">
          <svg viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="48" stroke="currentColor" strokeWidth="4" fill="none" />
          </svg>
        </i>
      ) : null}
    </CarouselButtonStyles.Button>
  );
};

export default CarouselButton;
